export default "__VITE_ASSET__CUvFiu6q__"